export interface Attachment {
  readonly url: string
  readonly fileName: string
  readonly contentType?: string
  readonly size?: number
  readonly width?: number
  readonly height?: number
}

interface MessageContent {
  readonly channelId: string
  readonly authorId: string
  readonly createdAt: number
  readonly text: string
  readonly attachments: readonly Attachment[]
}

export interface SentMessage extends MessageContent {
  readonly state: 'sent'
  readonly id: string
  readonly fakeId?: string
}

export interface SendingMessage extends MessageContent {
  readonly state: 'sending'
  readonly fakeId: string
}

export interface FailedMessage extends MessageContent {
  readonly state: 'failed'
  readonly fakeId: string
  readonly reason: string
}

export type ChatMessage = SentMessage | SendingMessage | FailedMessage

export function messageKey(message: ChatMessage): string {
  return message.state === 'sent' ? message.id : message.fakeId
}

export interface Chat {
  readonly id: string
  readonly isGroup: boolean
  readonly name: string
  readonly avatar?: string
  readonly memberIds: readonly string[]
  readonly createdAt: number
  readonly createdBy: string
  readonly lastMessageId?: string
  readonly isArchived: boolean
}

export interface Contact {
  readonly id: string
  readonly fullName: string
  readonly firstName?: string
  readonly lastName?: string
  readonly avatarUrl?: string
  readonly initials?: string
  readonly email?: string
  readonly globalRole?: string
}

export interface MessageReceivedEvent {
  readonly message: SentMessage
  readonly channelName?: string
}

export interface UnreadCount {
  readonly channelId: string
  readonly count: number
}
